export default __webpack_public_path__ + "static/media/Best-Worst-Leader-wordmark.177126d7.png";